import React from "react";
import { FieldListEditWrapper } from "cms/fields/field-lists/field-list-wrapper";
import DateFieldItemEdit from "./edit-item";

const DateFieldEdit = () => {
    
    return (
        <FieldListEditWrapper>
            <DateFieldItemEdit />
        </FieldListEditWrapper>
    );
};
DateFieldEdit.displayName = "DateFieldEdit";
export { DateFieldEdit };
